import { generateDataBagKeyType } from 'helper/offlineAvailability';
import { OfflineCallType } from '.';
import { REGISTER_DATA_BAG, REGISTER_OFFLINE_CALL } from './offlineAvailability.actionTypes';

export const actionCreators = {
	doRegisterDataBag: (DataBagKeyType: string, additionalPayload?: Object) => ({
		type: REGISTER_DATA_BAG,
		key: generateDataBagKeyType(DataBagKeyType, additionalPayload),
	}),
	doRegisterOfflineCall: ({ action, type }: OfflineCallType) => ({
		type: REGISTER_OFFLINE_CALL,
		call: { action, type },
	}),
};

export type OfflineAvailabilityActionType =
	| ReturnType<typeof actionCreators.doRegisterDataBag>
	| ReturnType<typeof actionCreators.doRegisterOfflineCall>;
